/*!
	Recipe Logic
*/

$(document).ready(function() {

	var grid, itemTemplate,
		pageData, renderNdx, dataKeys, renderTill;

	var xhr;
	function performSearch(cb)
	{
		if (xhr)
			xhr.abort();

		var payload = {
			action: 'da_recipe_search',
			terms: [],
			tags: [],
			search: []
		};

		$('#recipe-category-select option:selected').each(function() {
			var type = $(this).attr('data-select2-tag') ? 'search' : (this.className + 's');
			if (!payload[type]) {
				type = this.className;
			}
			
			payload[type].push(this.value);
		});

		xhr = $.ajax({
			url: BASEURL + '/wp-admin/admin-ajax.php',
			method: 'POST',
			dataType: 'json',
			data: payload
		});

		xhr.done(cb);
	}

	var preloadedImages = {};
	function preloadImages(urls, cb)
	{
		if (!Array.isArray(urls))
			urls = [urls];

		var left = urls.length;
		function loaded() {
			left--;
			if (!left)
				cb();
		}

		for (var i = 0; i < urls.length; i++)
		{
			if (!preloadImages[urls[i]])
			{
				preloadedImages[urls[i]] = new Image();
				preloadedImages[urls[i]].onload = loaded;
				preloadedImages[urls[i]].src = urls[i];
			}
			else
				loaded();
		}
	}

	function createItem(itemData)
	{
		var item = $(itemTemplate);
		item.attr('data-id', itemData.ID);
		item.find('.grid-box-title').text(itemData.title);
		//item.find('.grid-box-description').text(itemData.description);
		item.attr('href', itemData.url);

		grid
			.append(item)
			.isotope('appended', item);

		if (itemData.image)
		{
			preloadImages(itemData.image, function() {
				item.find('.grid-box-image').css('background-image', 'url(' + itemData.image + ')');
				item.addClass('image-loaded');
			});
		}
	}

	function updateView()
	{
		// Show loading
		$('body').addClass('loading');

		// Need search?
		if ($('#recipe-category-select').val().length)
		{
			$('body').addClass('searching');

			// Hide the archive top content
			$('.section-archive-content').slideUp();

			performSearch(function(resp) {
				// Hide loading
				$('body').removeClass('searching loading');

				var howMany = Object.keys(resp).length;
				if (resp.debug)
				{
					delete resp.debug;
					howMany--;
				}

				// Filter the current list
				var toRemove = $('.grid-box.ajax').filter(function() {
					var id = $(this).attr('data-id');
					if (resp[id])
					{
						delete resp[id];
						return false;
					}

					return true;
				});
				if (toRemove.length)
					grid.isotope('remove', toRemove);

				if (howMany)
				{
					$('.no-results').slideUp();

					pageData = resp;
					dataKeys = Object.keys(resp);
					renderNdx = 0;
					renderTill = Math.min(12, dataKeys.length);

					$(document).trigger('render-items');

					$('.load-more-row')[renderTill < dataKeys.length ? 'slideDown' : 'slideUp']();
				}
				else
				{
					$('.no-results').slideDown();
				}

				grid.isotope({
					filter: '.ajax'
				});
				setTimeout(function() {
					$(document).trigger('resize-box-titles', ['.ajax']);
				}, 0);
			});
		}
		else
		{
			$('body').removeClass('searching loading');
			$('.section-archive-content').slideDown();
			$('.no-results').slideUp();

			// Remove anything loaded via ajax
			grid
				.isotope('remove', $('.grid-box.ajax'))
				.isotope({
					filter: '.recipe-category'
				});
		}
	}

	function updateSelect2(options) {
		options = options || [];

		var select = $('#recipe-category-select');
		select.find('[data-select2-tag]').remove();

		options.forEach(function(val) {
			if (select.find('[value="' + val + '"]').length == 0) {
				select.append('<option value="' + val + '" data-select2-tag="true">' + val + '</option>');
			}
		});

		select.val(options).trigger('change');
	}

	$(document).on('click', '.btn-search-submit', function() {
		// Update href
		var hash = $('#recipe-category-select').val().join('/');
		if (!hash)
			hash = '_';
		location.href = BASEURL + '/recipe/#' + hash;
	});

	$(document).on('click', '.btn-search-reset', function() {
		$('#recipe-category-select').val([]).trigger('change');
		$(document).trigger('hashchange', ['_']);
	});

	$(document).on('click', '.btn-load-more', function() {
		renderTill = dataKeys.length;
		$('.load-more-row').slideUp();
		$(document).trigger('render-items');
	});

	$(document).on('click', '[data-recipe-search]', function(e) {
		e.preventDefault();

		location.href = BASEURL + '/recipe/#' + $(this).data('recipe-search');
	});

	$(document).on('render-items', function() {
		if (renderNdx >= renderTill)
			return;

		for (var j = 0; (renderNdx + j) < renderTill &&  j < 4; j++)
			createItem(pageData[dataKeys[renderNdx + j]]);

		renderNdx += j;

		setTimeout(function() {
			$(document).trigger('render-items');
		}, 50);
	});

	grid = $('.isotope-grid');
	if (grid.length)
	{
		itemTemplate = $('#grid-box-template').html().trim();
		$('body').append('<div class="searching-bg"/>');

		grid.isotope({
			itemSelector: '.grid-box',
			layoutMode: 'masonry'
		});

		$(window).on('hashchange', function(e, hashOverride) {
			// Update select box
			var hash = (hashOverride || location.hash.substr(1)),
				options = hash.replace('_', '').replace(/%20/g, ' ').split('/');

			if (options[0] == '') {
				options.splice(0, 1);
			}

			// What are we doing here? Setting the hash in a hash change function? This ensures the hash changes when the reset btn is clicked from the search page
			location.hash = hash;

			updateSelect2(options);

			// Calculate the position of the tag search bar
			var topPos = $('.section-search').offset().top - $('header .container').height() - ($('#wpadminbar').height() || 0);
			if ($(window).scrollTop() > topPos) {
				$('html, body').animate({ scrollTop: topPos }, 500);
			}

			updateView();
		});

		if (location.hash) {
			$(window).trigger('hashchange');
		}
	}

});
//WINDOW VIEWPORT
//Fixes issues with CSS and JS not matching up at browser/window sizes due to the scrollbar.
(function($) {
	var e = window, a = 'inner';
	if (!('innerWidth' in window )) {
		a = 'client';
		e = document.documentElement || document.body;
	}

	$.fn.viewport = function(options) {
		if (this.get(0) != window)
			return { width: this.outerWidth(), height: this.outerHeight() };
		return { width : e[ a+'Width' ] , height : e[ a+'Height' ] };
	};

	$.fn.viewportWidth = function(options) {
		if (this.get(0) != window)
			return this.outerWidth();
		return e[ a+'Width' ];
	};

	$.fn.viewportHeight = function(options) {
		if (this.get(0) != window)
			return this.outerHeight();
		return e[ a+'Height' ];
	};

	$.fn.filterByData = function(prop, val) {
		this.filter(
			function() { return $(this).data(prop)==val; }
			);
	};
})(jQuery);
jQuery(document).ready(function($) {
	// Global vars
	var windowWidth = 0,
	windowHeight = 0,
	scrollTop = 0,
	loading = true,
	$self, 
	$this,
	$window = $(window),	
	$document = $(document),	
	body = $('body'),
	header = $('.header'),
	main = $('.main'),
	footer = $('.footer');
	//boxTitle = $('.grid-box-title'),
	//boxDesc = $('.grid-box-description');

	/*====================================
	Window Events
	====================================*/

	$window.resize(function(e) {
		//Causes resize not to fire if the windows haven't actually changed (great for IE8)
		// if (windowWidth != $window.viewportWidth() || windowHeight != $window.viewportHeight()) {
		windowWidth = $window.viewportWidth();
		windowHeight = $window.viewportHeight();

			//Code goes here
		main.css('min-height', windowHeight - ( header.outerHeight(true) + footer.outerHeight(true) ) );
		// $('.custom-item').each(function(index, el) {
		// 	var polo = $(this);
		// 	var marco = polo.find('.item-content');
		// 	marco.css('padding-top', (polo.height() - marco.height()) / 2 );
		// });

		$document.trigger('resize-box-titles');
		$document.trigger('resize-box-descriptions');

		$('.grid-box-center .grid-box-content').each(function(index, el) {
			var self = $(this);
			var selfParent = self.parents('.grid-box-center');
			self.removeAttr('style');
			self.css('padding', ((selfParent.height() - self.height()) / 2) +'px 20px' );
		});
		// }
	}).resize();

	$window.on('load', function() {
		$window.resize();
	});

	/*====================================
	Document Events
	====================================*/

	$document.scroll(function(e) {
		scrollTop = $document.scrollTop();
		if (scrollTop > 100) {
			//forces browser to chill out for a moment if the page just loaded
			setTimeout(function() {
				body.addClass('scrolled');
			}, loading ? 500 : 0);
		} else {
			body.removeClass('scrolled');
		}
		// console.log(scrollTop);
	});

	$document.on('resize-box-titles', function(e, filter) {
		// var boxTitle = $((filter ? (filter + ' ') : '') + '.grid-box-title');
		var boxTitle = $('.grid-box-center .grid-box-title');
		var boxTitleHeights = boxTitle.map(function() {
			return $(this).height();
		}).get();
		var titleMaxHeight = Math.max.apply(null, boxTitleHeights);

		boxTitle.each(function(index, el) {
			var self = $(this);
			self.css('padding', (titleMaxHeight - self.height()) / 2 + 'px 0px');
		});
	});

	$document.on('resize-box-descriptions', function(e, filter) {
		// var boxDesc = $((filter ? (filter + ' ') : '') + '.grid-box-description');
		var boxDesc = $('.grid-box-center .grid-box-description');
		var boxTitleHeights = boxDesc.map(function() {
			return $(this).height();
		}).get();
		var titleMaxHeight = Math.max.apply(null, boxTitleHeights);

		boxDesc.each(function(index, el) {
			var self = $(this);
			self.css('padding', (titleMaxHeight - self.height()) / 2 + 'px 0px');
		});
	});

	//stops the browser loading delay 
	setTimeout(function() {
		loading = false;
	}, 500);

	$('.matchHeight').matchHeight();

});//End doc.ready

// $(window).on('load', function (e) {
// 	$(window).resize();
// });